import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from "@auth0/angular-jwt";
import { map, tap, catchError, switchMap, take, filter } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
   providedIn: 'root'
})
export class AuthService {

   private API = environment.BASE_API_URL;

   jwtHelper;

   constructor( private http: HttpClient, private router: Router ) {
      this.jwtHelper = new JwtHelperService();
   }

   login(user: string, pass: string,) {
      return this.http.post<any>(this.API + 'Login/login', {
         user, pass, keep_logged: true
      }, { withCredentials: false })
      .pipe(
         tap(data => {
            data.code === 0 ? this.storeTokens(data.access_token, data.refresh_token) : null;
         }),
         map(data => {
            return data;
         })
      );
   }
   loginWithToken() {

      console.log( localStorage.getItem('refresh_token'))
      console.log("viejo")
      return this.http.post<any>(this.API + 'Login/loginToken', {
         refresh_token: localStorage.getItem('refresh_token'),
      }, { withCredentials: false })
      .pipe(
         tap(data => {
            if ( data.code === 0 ){
               this.storeTokens(data.access_token, data.refresh_token);
            } else {
               this.removeTokens();
               this.router.navigate(['/clave'], {});
            }
         }),
         map(data => {
            return data;
         })

      );
   }
   logout() {
      this.http.get<any>(this.API + 'Login/logout', { withCredentials: false }).subscribe();
      localStorage.removeItem('username');
      this.removeTokens();
      this.router.navigate(['/']);
   }

   storeTokens(jwt, refresh_token) {
      localStorage.setItem('access_token', jwt);
      localStorage.setItem('refresh_token', refresh_token);

   }
   removeTokens() {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
   }

   isLogged() {
      const jwt = localStorage.getItem('access_token');
      const refresh_token = localStorage.getItem('refresh_token');

      if ( jwt ) {
         if ( this.jwtHelper.isTokenExpired(jwt) ) {
            return refresh_token !== undefined;
         } else {
            return true;
         }
      } else {
         return false;
      }
   }

   keepLogged() {
      const jwt = localStorage.getItem('access_token');
      //revisar
      // console.log("jwt "+jwt);
      if ( jwt && jwt!=='') {
         return this.jwtHelper.decodeToken(jwt).exp === undefined;
      } else {
         return false;
      }
   }

   getAccessToken() {
      return localStorage.getItem('access_token');
   }
   getRefreshToken() {
      return localStorage.getItem('refresh_token');
   }

   refreshToken() {
      const keep_logged = this.jwtHelper.decodeToken(localStorage.getItem('access_token')).exp === undefined;

      return this.http.post<any>(this.API + 'Login/refreshToken', {

         keep_logged: keep_logged,
         refresh_token: this.getRefreshToken()
      }, { withCredentials: false }).pipe(
         tap((tokens) => {
            this.storeTokens(tokens.access_token, tokens.refresh_token);
         })
      );
   }
}
